import cx from "classnames";
import type { EventStatusProps } from "@/features/shell/components/shared/EventStatus";
import { EventStatus } from "@/features/shell/components/shared/EventStatus";
import type {
  ClampShape,
  ClampVariant,
} from "@/features/shell/components/shared/EventStatus";
import type { StreamButtonProps } from "@/features/shell/components/shared/StreamButton";
import { StreamButton } from "@/features/shell/components/shared/StreamButton";
import { useCountdown } from "@/hooks/useCountdown";
import React from "react";
import type { StreamType } from "types/ContentTypes";

import * as styles from "./StatusWithStream.module.scss";

type StatusWithStreamProps = {
  clampShape?: ClampShape;
  clampVariant?: ClampVariant;
  className?: string;
  shouldHideStream?: boolean;
  showStreamCTA?: boolean;
} & EventStatusProps &
  Partial<Omit<StreamButtonProps<StreamType>, "startTime" | "status">>;

function StatusWithStream({
  title,
  url,
  sport,
  scheduledStartTime,
  showStreamCTA,
  status,
  bettingType,
  eventId,
  eventUrl,
  isPlaceholder,
  clampShape,
  clampVariant,
  className,
  shouldHideStream = false,
}: StatusWithStreamProps) {
  const [_, secondsToNow] = useCountdown(scheduledStartTime);
  const earlyBirdStream = secondsToNow <= 30 * 60; // 30 mins
  return (
    <div className={cx(styles.container, className)}>
      {url && earlyBirdStream && !shouldHideStream && (
        <StreamButton
          title={title ?? ""}
          sport={sport}
          url={url}
          startTime={scheduledStartTime ?? undefined}
          eventId={eventId}
          eventUrl={eventUrl}
          isPlaceholder={isPlaceholder}
          isCTA={showStreamCTA}
        />
      )}
      <EventStatus
        status={status}
        shape={clampShape}
        variant={clampVariant}
        scheduledStartTime={scheduledStartTime}
        bettingType={bettingType}
      />
    </div>
  );
}

export { StatusWithStream };
